import ee from '../../ee'

import initSplash from './splash'
import initProjects from './projects'

function init() {
  if (location.pathname === '/') {
    initSplash()
    initProjects()
  }
}

ee.addListener('initComponents', init)
